export default function CancelIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 6.99609L7 20.9961" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 6.99609L21 20.9961" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
